import { render, staticRenderFns } from "./AdminBidRequestButton.vue?vue&type=template&id=5e72a1d3"
import script from "./AdminBidRequestButton.vue?vue&type=script&lang=js"
export * from "./AdminBidRequestButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports